import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { InformationDto } from '../../../dto/justino/information.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { FileUploadService } from '../../../services/file-upload.service';
import { DominioService } from '../../../services/dominio.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { GestionInformacionService } from '../../../services/gestion-informacion.service';

@Component({
  selector: 'app-modal-editar-info-docs-ent',
  templateUrl: './modal-editar-info-docs-ent.component.html',
  styleUrl: './modal-editar-info-docs-ent.component.scss',
})
export class ModalEditarInfoDocsEntComponent {
  @ViewChild('modalEditar')
  modalEditar!: ElementRef;
  isDragging = false;

  @Input() docuemtalInfoRegister: InformationDto | null = null;

  constructor(
    private readonly alertService: AlertaModalService,
    private readonly fileUploadService: FileUploadService,
    private readonly dominioService: DominioService,
    private readonly spinnerService: SpinnerService,
    private readonly gestionInformacionService: GestionInformacionService
  ) {}

  abrirCerrarModal() {
    this.modalEditar.nativeElement.click();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  checkIfFileIsPdf(file: File): boolean {
    return file.type === 'application/pdf';
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (this.checkIfFileIsPdf(file)) {
        this.uploadFileProcess(file);
      } else {
        this.abrirCerrarModal();
        this.alertService.error('El archivo debe ser de tipo PDF (.pdf)');
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      input.value = '';
      this.uploadFileProcess(file);
    }
  }

  uploadFileProcess(file: any): void {
    this.fileUploadService
      .fileToBase64(file)
      .then(base64 => {
        this.dominioService
          .getDataSetContent(this.docuemtalInfoRegister?.DatasetId!)
          .subscribe({
            next: dataset => {
              if (dataset) {
                this.spinnerService.showSpinner();
                dataset.Contenido = base64;
                this.dominioService
                  .updateContenidoDatasetDominio(dataset)
                  .subscribe({
                    next: () => {
                      this.spinnerService.hideSpinner();
                      const updatedDocumentalInfo: InformationDto = {
                        ...this.docuemtalInfoRegister!,
                        FileName: file.name,
                        State: 1,
                        UpdatedAt: new Date().toISOString(),
                      };
                      this.updateDocumentalInfo(updatedDocumentalInfo);
                    },
                    error: () => {
                      this.spinnerService.hideSpinner();
                      this.abrirCerrarModal();
                      this.alertService.error(
                        'Error al cargar el archivo. Por favor, intente nuevamente.'
                      );
                    },
                  });
              } else {
                this.spinnerService.hideSpinner();
                this.abrirCerrarModal();
                this.alertService.error(
                  'Error al obtener el contenido del dataset. Por favor, intente nuevamente.'
                );
              }
            },
            error: () => {
              this.spinnerService.hideSpinner();
              this.abrirCerrarModal();
              this.alertService.error(
                'Error al obtener el contenido del dataset. Por favor, intente nuevamente.'
              );
            },
          });
      })
      .catch(error => {
        console.error('Error converting file to Base64:', error.error);
        this.abrirCerrarModal();
        this.alertService.error(
          'Error al convertir el archivo a Base64. Por favor, intente nuevamente.'
        );
      });
  }

  updateDocumentalInfo(data: InformationDto): void {
    this.gestionInformacionService
      .updateDocumentalInfoRegister(data)
      .subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.abrirCerrarModal();
          this.alertService.exito('El archivo se ha cargado correctamente.');
        },
        error: () => {
          this.spinnerService.hideSpinner();
          this.abrirCerrarModal();
          this.alertService.error(
            'Error al actualizar la información documental. Por favor, intente nuevamente.'
          );
        },
      });
  }
}
